// TODO: This functionality for reduced fields has to depend on a special attribute of the package, pickupable or something like that
function processCheckboxes() {
    let shippingEqualsBilling = document.getElementById('order_shipping_same_as_billing').checked;
    document.getElementById('billing_phone').style.display = shippingEqualsBilling ? 'initial' : 'none';
    document.getElementById('shipping_fields').style.display = shippingEqualsBilling ? 'none' : 'initial';
}

function showPricesForCurrency() {
    let country_id = document.getElementById("country_billing_selector").value;
    let huf_prices = document.getElementsByClassName('huf_price');
    let eur_prices = document.getElementsByClassName('eur_price');

    for (let element of huf_prices) {
        element.style.display = country_id == 13 ? 'initial' : 'none';
    }

    for (let element of eur_prices) {
        element.style.display = country_id == 13 ? 'none' : 'initial';
    }
}

function hideCouriersFromOtherCountries() {
    let shippingEqualsBilling = document.getElementById('order_shipping_same_as_billing').checked;
    let country_selector_id = shippingEqualsBilling ? 'country_billing_selector' : 'country_shipping_selector';
    let country_id = document.getElementById(country_selector_id).value;

    let couriers_to_show = document.getElementsByClassName("courier-checkbox-" + country_id);
    let all_couriers = document.getElementsByClassName('courier_checkbox');

    for (element of all_couriers) {
        element.style.display = 'none';
    }

    for (element of couriers_to_show) {
        element.style.display = 'block';
    }

    //Mark the first visible element
    let first_courier = document.getElementsByClassName("courier-checkbox-" + country_id)[0];
    first_courier.childNodes[1].checked = true
}

function setCourierSelectorEvents() {
    let courier_selectors = document.getElementsByClassName('courier_selector')
    for (selector of courier_selectors) {
        if (selector.value == 14) {
            selector.addEventListener('click', () => {
                window.$("#foxpostModal").modal('show');
            });
        } else {
            selector.addEventListener('click', () => {
                document.getElementById('order_locker_info').value = '';
            });
        }
    }
}


document
    .querySelector("#order_shipping_same_as_billing")
    .addEventListener("change", processCheckboxes, false);

document
    .querySelector("#country_billing_selector")
    .addEventListener("change", showPricesForCurrency, false);

document
    .querySelector("#country_billing_selector")
    .addEventListener("change", hideCouriersFromOtherCountries, false);
document
    .querySelector("#order_shipping_same_as_billing")
    .addEventListener("change", hideCouriersFromOtherCountries, false);

document
    .querySelector("#country_shipping_selector")
    .addEventListener("change", hideCouriersFromOtherCountries, false);

processCheckboxes();
showPricesForCurrency();
hideCouriersFromOtherCountries();
setCourierSelectorEvents();